import { MapPin, Users, Home, Clock } from "lucide-react";

const STATS = [
  {
    icon: MapPin,
    value: "30",
    label: "Villes couvertes",
    detail: "Côte d'Émeraude · Morbihan",
  },
  {
    icon: Home,
    value: "3",
    label: "Départements",
    detail: "Ille-et-Vilaine · Côtes-d'Armor · Morbihan",
  },
  {
    icon: Users,
    value: "70",
    label: "Logements pas plus",
    detail: "Volume volontairement limité",
  },
  {
    icon: Clock,
    value: "30 min",
    label: "Délai d'intervention",
    detail: "City Manager local sur place",
  },
];

const CityStatsBar = () => (
  <section
    className="py-14 lg:py-16 bg-white border-b border-ink/8"
    data-testid="city-stats-bar"
  >
    <div className="container-tm">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-y-10 gap-x-6 lg:gap-x-10">
        {STATS.map((s, i) => {
          const Icon = s.icon;
          return (
            <div
              key={i}
              data-testid={`city-stat-${i}`}
              className="text-center md:text-left md:border-l md:first:border-l-0 md:border-ink/10 md:pl-6 lg:pl-10"
            >
              <Icon
                size={18}
                strokeWidth={1.8}
                className="text-gold mb-3 inline-block md:block"
              />
              <p
                className="font-serif italic font-light text-ink leading-none tracking-tight"
                style={{ fontSize: "clamp(40px, 5vw, 64px)" }}
              >
                {s.value}
              </p>
              <p className="mt-2 font-sans text-sm font-semibold text-ink uppercase tracking-[0.12em]">
                {s.label}
              </p>
              <p className="mt-1 font-sans text-xs text-ink/55">{s.detail}</p>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

export default CityStatsBar;
